import { AuditColumnModel, PaginationPayloadModel, StatusModel, TenantModel } from '../general';

export interface DeviceListModel extends AuditColumnModel {
  description: string;
  name: string;
  createdDate: string;
  deviceId: string;
  deviceName: string;
  deviceType: string;
  lastActiveDate?: string;
  status?: StatusModel;
  serialNumber: string;
  tenantDetails: TenantModel;
  runningStatusRenderer: any;
  expiryDate: string;
  tagUntagStatus: boolean;
  warningStatus: boolean;
  modifiedDate: string
  endTime: string;
  startTime: string;
  reportingIntervalInMs: number;
  samplingIntervalInMs: number;
  remarks: string;
  batchId: string;
  totalAttachedDevices: number;
  scheduledFrom: string;
  scheduledTo: string;
  type: string;
  batchDetails: BatchDetails
}

export interface DeviceListPayloadModel extends PaginationPayloadModel {
  searchKey: string;
  type: string;
}

export interface DeviceRealTimePayloadModel {
  nodeId: string;
  deviceId: string;
}

export interface DeviceRealTimePayloadModelv1 {
  timeRange: {
    from: number;
    to: number;
  };
  deviceList: string[];
}

export interface DeviceRealTimeListModel {
  deviceId?: string;
  nodeId?: string;
  lastActiveDate: string;
  status?: StatusModel;
  overAllHealth?: StatusModel;
}



export interface DeviceRealTimeListModelV1 {
  deviceId: string;
  lastActiveDate: string;
  overAllHealth?: StatusModel;
}


export interface DeviceRealTimeData {
  deviceId: string;
  lastActiveDate: string;
  overAllHealth?: StatusModel;
  moduleHealth?: StatusModel;
  peripheralHealth?: StatusModel;
  message: string;
}

interface User {
  _id: string;
  name: string;
}

interface Metadata {
  createdDate: string;
  modifiedDate: string;
  createdBy: User[];
  modifiedBy: User[];
}

interface TemplateDetails {
  _id: string;
  templateId: string;
  csvUrl: string;
}

interface BatchDetails {
  _id: string;
  batchId: string;
  csvUrl: string | null;
  scheduledFrom: string;
  scheduledTo: string;
  startTime: string;
  endTime: string;
  reportingIntervalInMs: number;
  samplingIntervalInMs: number;
  endPointId?: string;
  endPointType: string;
  scheduledStatus: boolean;
  runningStatus: boolean;
  actionStatus: string;
  metadata: Metadata;
  remarks: string;
  totalAttachedDevices: number;
  type: string;
  templateDetails: TemplateDetails[];
}

